import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { Box, Button, Link } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { useNavigate } from "react-router-dom";
import { ALL_ROUTES } from "../../../../../Routes/all_routes";
import "./../BulkUpload.scss";

function MapFieldsConfirmation() {
  const navigate = useNavigate();

  const updateMasterState = (attrName: any, value: any) => {
    attrName(value);
  };
  return (
    <Box className="BulklayoutWrapper">
      {/* Page header */}
      <Grid container spacing={3} className="pageHeader">
        <Grid xs={6} className="pageTitle">
          <Link
            className="backStep"
            onClick={() => {
              navigate(-1);
            }}>
            <ChevronLeftIcon />
          </Link>

          <div>
            <h3> Import from Spreadsheet</h3>
          </div>
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid xs={12} className="innerSection pl-10 pr-10">
          <Grid container spacing={3}>
            <Grid xs={12} className="mapfields_instructions mt-3 mb-4">
              <p>Confirm Mapping</p>
              <p style={{ fontWeight: "500", color: "#666666" }}>
                The following columns in your import file are not mapped with
                any of the Add New Contact Form fields. If you continue, the
                data in these columns will not be imported. Click the Previous
                button to go back and map these fields. If you wish to continue,
                click the Import button.
              </p>
              <ul className="mapcolumnList">
                <li>City (Column: 4)</li>
                <li>State (Column: 11)</li>
                <li>Last Name (Column: 2)</li>
                <li>Email (Column: 7)</li>
                <li>Mobile Number (Column: 9)</li>
                <li>Department (Column: 14)</li>
              </ul>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Grid container spacing={3} className="footerSection">
        <Grid xs={12} className="ctaBtn">
          <Button
            variant="outlined"
            className="borderBtn"
            onClick={() => navigate(-1)}>
            Previous
          </Button>
          <Button
            variant="outlined"
            className="borderBtn"
            onClick={() => {
              navigate(-3);
            }}>
            Cancel
          </Button>
          <Button
            variant="contained"
            className="submitBtn"
            onClick={() => navigate(ALL_ROUTES.BULK_UPLOAD_LIST)}>
            Import
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
}

export default MapFieldsConfirmation;
